import { makeAutoObservable } from "mobx";
import { SearchObject } from "app/common/Model/SearchObject";
import { 
    pagingSpecialist, 
    getSpecialistById, 
    getAllSpecialist, 
    saveSpecialist, 
    deleteSpecialist 
} from 'app/services/SpecialistService';
import { Specialist } from "app/common/Model/Specialist";
import { checkSearchObject } from "app/common/LocalFunction";
import { toast } from "react-toastify";

export default class SpecialistStore {
    listAllSpecialist = [];
    searchSpecialist = new SearchObject();
    pageSpecialist = null;
    selectedSpecialist = null;
    openFormCreateOrEdit = false;
    openConfirmDeleteSpecialist = false;

    constructor() {
        makeAutoObservable(this);
    }

    getAllSpecialist = () => {
        if (this.listAllSpecialist?.length === 0) {
            getAllSpecialist()
                .then(({ data }) => this.listAllSpecialist = data)
                .catch((error) => {
                    console.error(error);
                    toast.error("Lấy dữ liệu có lỗi");
                });
        }
    }

    pagingSpecialist = () => {
        pagingSpecialist(this.searchSpecialist)
            .then(({ data }) => {
                this.pageSpecialist = data;
            })
            .catch((error) => {
                console.error(error);
                toast.error("Lấy dữ liệu có lỗi");
            })
    }

    handleChangeFormSearch = (searchSpecialist) => {
        this.searchSpecialist = checkSearchObject(this.searchSpecialist, searchSpecialist);
        this.pagingSpecialist();
    }

    handleOpenFormCreateOrEdit = (specialistId) => {
        if (Boolean(specialistId)) {
            getSpecialistById(specialistId)
                .then(({ data }) => {
                    this.selectedSpecialist = data;
                    this.openFormCreateOrEdit = true;
                })
                .catch((error) => {
                    console.error(error);
                    toast.error("Lấy dữ liệu có lỗi");
                })
        } else {
            this.selectedSpecialist = new Specialist();
            this.openFormCreateOrEdit = true;
        }
    }

    saveSpecialist = (specialist, { setSubmitting }) => {
        return saveSpecialist(specialist).then(() => {
            this.selectedSpecialist = null;
            toast.success("Lưu chuyên khoa thành công!");
            this.handleClosePopup();
            this.pagingSpecialist();
        })
            .catch(error => {
                console.error(error);
                toast.error("Lưu thông tin chuyên khoa có lỗi");
            })
            .finally(() => setSubmitting(false))
    }

    handleDeleteSpecialist = (specialist) => {
        this.selectedSpecialist = { id: specialist?.id };
        this.openConfirmDeleteSpecialist = true;
    }

    handleConfirmDeleteSpecialist = () => deleteSpecialist(this?.selectedSpecialist?.id)
        .then(() => {
            if (this.searchSpecialist.pageIndex > 1 && this.pageSpecialist.content.length === 1) {
                this.searchSpecialist.pageIndex -= 1;
            }
            toast.success("Xóa chuyên khoa thành công!")
            this.handleClosePopup();
            this.pagingSpecialist();
        })
        .catch(err => {
            console.error(err);
            toast.error("Xóa chuyên khoa có lỗi");
        })

    handleClosePopup = () => {
        this.openFormCreateOrEdit = false;
        this.openConfirmDeleteSpecialist = false;
    }

    resetStore = () => {
        this.searchSpecialist = new SearchObject();
        this.pageSpecialist = null;
        this.selectedSpecialist = null;
        this.openFormCreateOrEdit = false;
        this.openConfirmDeleteSpecialist = false;
    }
}